<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>员工管理</el-breadcrumb-item>
      <el-breadcrumb-item>修改员工档案</el-breadcrumb-item>
    </el-breadcrumb>
        <div style="width: 100%;display: flex;justify-content: center">
          <span style="color: #f78989;font-size: 18px">员工档案</span>
        </div>
        <span style="color: #8cc5ff;font-size: 14px">基本信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">员工姓名：</span>
              <el-input v-model="userCard.userName" readonly
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">员工电话：</span>
              <el-input v-model="userCard.userPhone" readonly
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">身份证号：</span>
              <el-input v-model="userCard.idNum"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">出生日期：</span>
              <el-date-picker
                v-model="userCard.birthday"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.birthday"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">部门：</span>
              <el-input v-model="userCard.shopName"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">工号：</span>
              <el-input v-model="userCard.userCode"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">年龄：</span>
              <el-input v-model="userCard.age"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">民族：</span>
              <el-input v-model="userCard.nation"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">性别：</span>
              <el-input v-model="userCard.sex"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">职位：</span>
              <el-input v-model="userCard.position"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">座机：</span>
              <el-input v-model="userCard.telephone"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">邮箱：</span>
              <el-input v-model="userCard.email"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">家庭住址：</span>
              <el-input v-model="userCard.address"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">婚姻状况：</span>
              <el-input v-model="userCard.marital"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around; margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">政治面貌：</span>
              <el-input v-model="userCard.politics"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">户籍类别：</span>
              <el-select v-model="userCard.census" size="mini" style="width: 50%;" placeholder="请选择">
                <el-option
                  v-for="item in censusList"
                  :key="item.index"
                  :label="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">健康信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">身高：</span>
              <el-input v-model="userCard.height"
                        size="mini" style="width: 50%;"></el-input><span style="color: #8c939d;font-size: 14px">cm</span>
            </div>
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">体重：</span>
              <el-input v-model="userCard.weight"
                        size="mini" style="width: 50%;"></el-input><span style="color: #8c939d;font-size: 14px">kg</span>
            </div>
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">服装尺码：</span>
              <el-input v-model="userCard.dressSize"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">鞋子尺码：</span>
              <el-input v-model="userCard.shoeSize"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">教育信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">学历：</span>
              <el-input v-model="userCard.education"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">专业：</span>
              <el-input v-model="userCard.specialty"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around;margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">毕业学校：</span>
              <el-input v-model="userCard.school"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">毕业时间：</span>
              <el-date-picker
                v-model="userCard.leaveSchoolTime"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.leaveSchoolTime"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">银行信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">银行卡号：</span>
              <el-input v-model="userCard.cardNo"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">开户行：</span>
              <el-input v-model="userCard.bank"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around;margin-top: 20px">
            <div style="width: 100%">
              <span style="color: #8c939d;font-size: 14px">开户名：</span>
              <el-input v-model="userCard.bankUserName"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">合同信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">合同开始时间：</span>
              <el-date-picker
                v-model="userCard.contractStartDate"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.contractStartDate"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
            <div style="width: 30%">
              <span style="color: #8c939d;font-size: 14px">合同结束时间：</span>
              <el-date-picker
                v-model="userCard.contractEndDate"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.contractEndDate"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
          </div>
        </el-card>
        <span style="color: #8cc5ff;font-size: 14px">其他信息</span>
        <el-card>
          <div style="width: 100%;display: flex;justify-content: space-around">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">入职时间：</span>
              <el-date-picker
                v-model="userCard.entryTime"
                type="date"
                size="mini"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
<!--              <el-input v-model="userCard.entryTime"-->
<!--                        size="mini" style="width: 50%;"></el-input>-->
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">介绍人：</span>
              <el-input v-model="userCard.introducer"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-around;margin-top: 20px">
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">紧急联系人：</span>
              <el-input v-model="userCard.emergencyContact"
                        size="mini" style="width: 50%;"></el-input>
            </div>
            <div style="width: 50%">
              <span style="color: #8c939d;font-size: 14px">紧急联系人电话：</span>
              <el-input v-model="userCard.emergencyContactPhone"
                        size="mini" style="width: 50%;"></el-input>
            </div>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
            <span style="color: #8c939d;font-size: 14px">工作简历：</span>
            <el-input v-model="userCard.resume" type="textarea"
                      size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
            <span style="color: #8c939d;font-size: 14px">人生感言：</span>
            <el-input v-model="userCard.lifeTestimonial" type="textarea"
                      size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
              <span style="color: #8c939d;font-size: 14px">参与过的培训：</span>
              <el-input v-model="userCard.train" type="textarea"
                        size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
              <span style="color: #8c939d;font-size: 14px">加入朋朋原因：</span>
              <el-input v-model="userCard.reason" type="textarea"
                        size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
              <span style="color: #8c939d;font-size: 14px">企业内部荣誉：</span>
              <el-input v-model="userCard.inHonor" type="textarea"
                        size="mini" style="width: 90%;"></el-input>
          </div>
          <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
              <span style="color: #8c939d;font-size: 14px">政府机构荣誉：</span>
              <el-input v-model="userCard.govHonor" type="textarea"
                        size="mini" style="width: 90%;"></el-input>
          </div>
        </el-card>
        <div style="margin-top:10px;display: flex;justify-content: space-between;align-items: flex-end">
          <span style="color: #8cc5ff;font-size: 14px">家庭成员</span>
          <el-button size="mini"  @click="addRow">添加一行</el-button>
        </div>
        <el-card>
          <el-form>
            <el-table :data="familyList" fit border stripe="stripe"
                      :cell-style="{padding: '5px'}"
                      :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                      :row-style="{height: '0'}">
              <el-table-column
                align="center"
                label="操作" >
                <template slot-scope="scope">
                  <el-link type="danger" icon="el-icon-delete"
                           @click="deleteRow(scope.row, scope.$index)"></el-link>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="家人姓名" >
                <template slot-scope="scope">
                  <el-form-item
                    size="mini" style="margin-bottom: 0"
                    :prop="'familyList.' + scope.$index + '.familyName'"
                  >
                    <el-input size="mini" v-model="scope.row.familyName"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="家人电话" >
                <template slot-scope="scope">
                  <el-form-item
                    size="mini" style="margin-bottom: 0"
                    :prop="'familyList.' + scope.$index + '.familyPhone'"
                  >
                    <el-input size="mini" v-model="scope.row.familyPhone"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="从属关系" >
                <template slot-scope="scope">
                  <el-form-item
                    size="mini" style="margin-bottom: 0"
                    :prop="'familyList.' + scope.$index + '.familyRelation'"
                  >
                    <el-input size="mini" v-model="scope.row.familyRelation"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-card>
        <el-button size="mini" @click="editCard">保存</el-button>
  </div>
</template>

<script>
export default {
  data(){
    return {
      orgId:'',
      userId:'',
      orgList: [],
      userList: [],
      selectUserId:'',
      selectOrg:'',
      selectedUser:'',
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      userDialogVisible:false,
      userCard:{
        userId:'',
        userName:'',
        userPhone:'',
        shopName:'',
        idNum:'',
        birthday:'',
        userCode:'',
        age:'',
        nation:'',
        sex:'',
        position:'',
        telephone:'',
        email:'',
        address:'',
        marital:'',
        politics:'',
        census:'',
        height:'',
        weight:'',
        dressSize:'',
        shoeSize:'',
        education:'',
        specialty:'',
        school:'',
        leaveSchoolTime:'',
        cardNo:'',
        bank:'',
        bankUserName:'',
        introducer:'',
        entryTime:'',
        emergencyContact:'',
        emergencyContactPhone:'',
        lifeTestimonial:'',
        train:'',
        reason:'',
        inHonor:'',
        govHonor:'',
        resume:'',
        contractStartDate:'',
        contractEndDate:'',
        familyList:[]
      },
      familyList:[],
      family:{
        familyName: '',
        familyPhone: '',
        familyRelation: '',
      },
      isNew:false,
      censusList:[
        {index:1, value:'农业户口'},
        {index:2, value:'城镇户口'}
      ],
      searchText:'',
    }
  },
  methods:{
    async loadUserCard(data){
      const {data:res} = await this.$http.get(`/load/user/card/${data}`);
      this.userCard = res.data;
      this.familyList = res.data.familyList;
    },
    addRow(){
      const item = {
        familyName: '',
        familyPhone: '',
        familyRelation: ''
      }
      this.familyList.push(item);
    },
    deleteRow(row, index){
      this.familyList.splice(index, 1);
    },
    async editCard(){
      this.userCard.familyList = this.familyList;
      const {data:res} = await this.$http.post(`/edit/user/card`, this.userCard);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      this.$router.go(-1)
    },
  },
  created() {
    this.userId = this.$route.query.id;
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadUserCard(this.userId);
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EditUserCard.vue